$mol_icon_rectangle_outline $mol_icon path \M4,6V19H20V6H4M18,17H6V8H18V17Z
